<section class="sidebar">
    <ul class="sidebar-menu" data-widget="tree">
        <li class="active treeview"> <a  [routerLink]="['/dashboard']"> <i class="fa fa-home"></i> <span>Home</span> </a> </li>
        <li class="treeview"> <a  [routerLink]="['/pending-cases']"> <i class="fa fa-list-alt"></i> <span>Pending Cases</span> </a></li>
        <!-- <li class="treeview"> <a  [routerLink]="['/claim-assignment']" *ngIf="LoginDetails.UserType==1 || (LoginDetails.UserType==2 && LoginDetails.InsurerId == 6 )"> <i class="fa fa-pencil-square-o"></i> <span>Claim Assignment</span> </a> </li> -->
        <!-- <li class="treeview"> <a  [routerLink]="['/claim-assignment']" > <i class="fa fa-pencil-square-o"></i> <span>Claim Assignment</span> </a> </li> -->
    </ul>
</section>
